/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  configure-wireless-actions.ts
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Suresh Jaladi (E807958)
 *
 * @Date	     : 05 November 2019
 *
 * @Version      : Version 1.0
 *
 * By            : E844276
 * On            : Nov 18, 2019
 * Description   : Added generic product functionalities - removed from products
 *
 * By            : E807958
 * On            : Nov 21, 2019
 * Description   : ASDS-1801, ASDS-1802, ASDS-1803, ASDS-1804
 *
 * By            : H224423
 * On            : Nov 28, 2019
 * Description   : ASDS-1474 Accept product terms changes.
 *
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1953
 *
 * By            : Suresh Jaladi (E807958)
 * On            : 3 Dec 2019
 * Description   : ASDS-1958
 *
 * By            : Suresh Jaladi - E807958
 * On            : Dec 06, 2019
 * Description   : ASDS-1811
 *
 * By            : H224423
 * On            : 12 Dec, 2019
 * Description   : Terms Checkbox default checked issue fix.
 *
 * By            : Madhu Gali
 * On            :  Dec 18, 2019
 * Description   : ASDS-584
 *
 * By            : Deepthi Bachu - E844276
 * On            : 06 Feb, 2020
 * Description   : ASDS-1957 - Wireless - Add To Cart - Block Adding Serial Number if already in Cart
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes.
 *
 * By            : E844276
 * On            : Aug 04, 2020
 * Description   : Removed accountType and OEM parameters for custom pricing
 *
* By             : H422337
 * On             : Sep 07,2020
 * Description    : ASDS-2570 UI enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 10,2020
 * Description    : ASDS-3140 UI enhancements  phase-2 bugfixes
 *
 * By            : H422336
 * On            : Oct 9, 2020
 * Description   : ASDS - 3259 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 27, 2020
 * Description   : ASDS-3552 - UI Enhancements for Phase - II -migrate to Forge API
 *
 * By            : H422337
 * On            : Oct 27, 2020
 * Description   : ASDS-3555 & ASDS-3554 - UI Enhancements for Phase - II -Migrate to Forge API
 *
 * By            : H422337
 * On            : Nov 19, 2020
 * Description   : ASDS -4084 -UI Enhancements for Phase - II  bug fix -Error should not be displayed in the step 1 of product configuration
 *
 ******************************************************************************/

import Action from './Action';
import ActionConstants from '../action-constants';
import { AircraftErrorLabels, CheckoutUILabels, CheckoutConstants } from './../../constants/checkout-constants';
import { indexOfAll, validateAircraftType } from './../../utils/aircraft-validations';
import ProductAlertActions from './products-alerts-action';
import routeConstants from 'modules/checkout/constants/route-constants';
import CartDetailsActions from './cart-details-actions';
import OrderSummaryActions from './order-summary-actions';
import CartDetails from '../../API/cart-detials-api';

const validateAircraftInputData = (inputData: any, validateFields: any, aircraftSerialsInCart: [], aircraftTailsInCart: []) => {
    const validatedData = inputData.map((aircraft) => {
        let errorMsg = {
            aircraftTypeError: '',
            serialNumberError: '',
            tailNumberError: '',
        };
        let validInputData = true;

        if (validateAircraftType(aircraft.aircraftType)) {
            validInputData = false;
            if (validateFields.indexOf('aircraftType') > -1) {
                errorMsg.aircraftTypeError = AircraftErrorLabels.AIRCRAFT_TYPE_ERROR;
            }
        }

        if (!aircraft.serialNumber) {
            validInputData = false;
            if (validateFields.indexOf('serialNum') > -1) {
                errorMsg.serialNumberError = AircraftErrorLabels.AIRCRAFT_SERIAL_ERROR_EMPTY;
            }
        }
        else {
            const serialNumberList = inputData.map((obj) => obj.serialNumber);
            const duplicateIndex = indexOfAll(serialNumberList, aircraft.serialNumber);
            // check of the duplicates, if found update the error msg.
            if (duplicateIndex.length > 1) {
                errorMsg.serialNumberError = AircraftErrorLabels.AIRCRAFT_DUPLICATE_SERIAL_ERROR;
                validInputData = false;
            }
            // Check if serial number is duplicated from the cart items
            if (validateFields.indexOf('cartDuplicateSl') > -1) {
                const cartDupSerNo = indexOfAll(aircraftSerialsInCart, aircraft.serialNumber);
                if (cartDupSerNo.length) {
                    errorMsg.serialNumberError = AircraftErrorLabels.DUPLICATE_SERIAL_CART_ERROR;
                    validInputData = false;
                }
            }
        }

        if (!aircraft.tailNumber) {
            validInputData = false;
            if (validateFields.indexOf('tailNum') > -1) {
                errorMsg.tailNumberError = AircraftErrorLabels.AIRCRAFT_TAIL_ERROR_EMPTY;
            }
        }
        else {
            const tailNumberList = inputData.map((obj) => obj.tailNumber);
            const duplicateIndex = indexOfAll(tailNumberList, aircraft.tailNumber);
            // check of the duplicates, if found update the error msg.
            if (duplicateIndex.length > 1) {
                errorMsg.tailNumberError = AircraftErrorLabels.AIRCRAFT_DUPLICATE_TAIL_ERROR;
                validInputData = false;
            }
            // Check if tail number is duplicated from the cart items
            if (validateFields.indexOf('cartDuplicatetl') > -1) {
                const cartDupSerNo = indexOfAll(aircraftTailsInCart, aircraft.tailNumber);
                if (cartDupSerNo.length) {
                    errorMsg.tailNumberError = AircraftErrorLabels.DUPLICATE_TAIL_CART_ERROR;
                    validInputData = false;
                }
            }
        }

        return { ...aircraft, ...errorMsg, validInputData };
    });
    const errors = validatedData.filter((aircraft) => {
        return !aircraft.validInputData;
    });

    const hasErrors = errors.length > 0;  // returns true if there is any error msg present in validated array
    return { validatedData, hasErrors };
};

const saveToCartObjMapper = function (productDetails: any, OpType: string) {

    const wirelessLineItemDetails: any = [];
    productDetails.productData.map(product => {
        wirelessLineItemDetails.push({
            aircraftType: product.aircraftType.name,
            aircraftTailNo: product.tailNumber,
            unitPrice: product.price ? parseFloat(product.price) : 0,
            aircraftSerialNum: product.serialNumber,
        });
    });

    let cartObj: any;
    if (OpType === CheckoutConstants.OPERATION_TYPE_SAVE) {
        cartObj ={
            cart: {seq :productDetails.cartSeq ? productDetails.cartSeq : 0,
                productsRequest: [{
                wireless: wirelessLineItemDetails,
                userId: productDetails.userID,
                prodId: productDetails.productId,
                prodName: productDetails.productName,
                prodDesc: productDetails.productDesc,
                system: productDetails.system,
                categoryName: productDetails.categoryName

    }]
    }
    }
}
    else {
        cartObj = {
            cart: {
                seq: productDetails.cartSeq,
                productsRequest: [{
                  id: productDetails.id,
                  cartSeq: productDetails.cartSeq,
                  wireless: wirelessLineItemDetails,
                  userId: productDetails.userID,
                  prodId: productDetails.productId,
                  prodName: productDetails.productName,
                  prodDesc: productDetails.productDesc,
                  system: productDetails.system,
                 categoryName: productDetails.categoryName

    }]
    }
    }

    }
    return cartObj;
};

class ConfigureWirelessActions extends Action {
    static gotoNextTabWireless() {
        return (dispatch, getState) => {
            let activeTab = getState().configWirelessProductData.payload.activeTab;
            dispatch({
                type: ActionConstants.HIDE_VALIDATION_ERROR_MSG,
                payload: {
                    showValidationErrorMsg: true
                }
            });

            if (activeTab === 1) {
                activeTab = activeTab + 1;

                const wirelessPayload = getState().configWirelessProductData.payload;

                let serialsInCart = ConfigureWirelessActions.serialsIncart(wirelessPayload);
                let tailsInCart = ConfigureWirelessActions.tailsIncart(wirelessPayload);

                const validationFields = ['aircraftType', 'serialNum', 'cartDuplicateSl', 'tailNum', 'cartDuplicatetl'];
                const { validatedData, hasErrors } = validateAircraftInputData(wirelessPayload.aircraftDetailsArray, validationFields, serialsInCart, tailsInCart);
                if (hasErrors) {
                    const updatedAircraftsData = [...validatedData];
                    dispatch({
                        type: ActionConstants.WIRELESS_ADD_AIRCRAFT,
                        payload: {
                            updatedAircraftsData,
                            enableNextBtn: false
                        }
                    });
                } else if (!wirelessPayload.acceptTermsStatus) {
                    dispatch({
                        type: ActionConstants.UPDATE_WIRELESS_ACCEPT_TERMS_STATUS,
                        payload: {
                            acceptTermsErrorMsg: CheckoutUILabels.WIRELESS_PRODUCT_TERMS_ERROR_MSG,
                            enableNextBtn: false,
                        }
                    });
                } else {
                    dispatch({
                        type: ActionConstants.WIRELESS_GOTO_CONFIRM_CONFIG,
                        payload: {
                            activeTab,
                            nextbtn: 'ADD TO CART',
                        }
                    });
                }
            }
            else {
                let {
                    productsInCart,
                    system,
                    categoryName,
                    product,
                    aircraftDetailsArray,
                    editWirelessProductDetails
                } = getState().configWirelessProductData.payload;
                const userID = getState().userValidationData.payload.userInfo.customer_sub;

                aircraftDetailsArray.forEach(data => {
                    data.price = product.price;
                });

                let productDetails = {
                    ...product,
                    system,
                    categoryName,
                    userID,
                    productData: aircraftDetailsArray,
                    productSeq: editWirelessProductDetails.productSeq,
                    seq: editWirelessProductDetails.seq,
                    id: editWirelessProductDetails.id,
                    cartSeq: editWirelessProductDetails.cartSeq
                };

                productsInCart = [...productsInCart, productDetails];

                ProductAlertActions.hideAlert();

                if (!productDetails.productSeq) {
                    const cartProduct = saveToCartObjMapper(productDetails, CheckoutConstants.OPERATION_TYPE_SAVE);
                    productsInCart = [...productsInCart, cartProduct];
                    // SAVE TO CART
                    dispatch({
                        type: ActionConstants.ADD_PRODUCT_TO_CART_LOADER,
                        payload: {
                            addProductToCartInProgress: true,
                        },
                    });

                    CartDetails.saveProductToCart(cartProduct, productDetails.userID).then(response => {
                        let isAddToCartSuccess = false;
                        if (response) {
                            isAddToCartSuccess = true;
                            dispatch({ // dispatching action to add the product to CART items.
                                type: ActionConstants.ADD_WIRELESS_PRODUCT_TO_CART,
                                payload: {
                                    productsInCart: productsInCart,
                                }
                            });

                            dispatch(ProductAlertActions.setGenricFields(system));
                            dispatch({
                                type: ActionConstants.OPEN_CART_ICON,
                                payload: {
                                  openCartIcon: true
                                }
                              });
                            dispatch({
                                type: ActionConstants.CLOSE_WIRELESS_MODEL,
                                payload: {}
                            });
                            dispatch({   // dispatching action to reset the configure product data.
                                type: ActionConstants.WIRELESS_RESET_CONFIGURATION,
                                payload: {}
                            });
                            CartDetailsActions.getCartData(userID, 'abstract')(dispatch, getState); // This will update the cart Count for user
                        }

                        dispatch({   // dispatching action to update last product added to cart
                            type: ActionConstants.UPDATE_LAST_PROD_CART,
                            payload: {
                                lastProdAddedToCart: productDetails.productName,
                            }
                        });
                        dispatch({
                            type: ActionConstants.SET_ALERT_MODEL,
                            payload: {
                                showAlertMsg: true,
                                isAddToCartSuccess: isAddToCartSuccess
                            }
                        });
                        dispatch({   // dispatching action to hide add to cart loader
                            type: ActionConstants.ADD_PRODUCT_TO_CART_LOADER,
                            payload: {
                                addProductToCartInProgress: false,
                            }
                        });
                    });
                }
                else {
                    dispatch({
                        type: ActionConstants.SET_TOASTER,
                        payload: {
                            notify: 'bottom-right'
                        }
                    });
                    const cartProduct = saveToCartObjMapper(productDetails, CheckoutConstants.OPERATION_TYPE_EDIT);
                    productsInCart = [...productsInCart, cartProduct];
                    // EDIT CART
                    dispatch({
                        type: ActionConstants.EDIT_PRODUCT_TO_CART_LOADER,
                        payload: {}
                    });

                    CartDetails.editProductToCart(cartProduct, productDetails.userID).then(response => {
                        let isUpdateToCartSuccess = false;
                        if (response) {
                            isUpdateToCartSuccess = true;
                            dispatch({ // dispatching action to add the product to CART items.
                                type: ActionConstants.ADD_WIRELESS_PRODUCT_TO_CART,
                                payload: {
                                    productsInCart: productsInCart,
                                }
                            });
                            dispatch(
                                // get cart products & updates cart count
                                CartDetailsActions.getCartData(userID, 'both')
                            );
                            dispatch(
                                // updates order summary
                                OrderSummaryActions.getOrderSummary(userID)
                            );

                        } else {

                            dispatch(
                                CartDetailsActions.showErrorOnEditProduct(product.productName)
                            );
                        }
                        dispatch({   // dispatching action to update last product added to cart
                            type: ActionConstants.UPDATE_LAST_PROD_CART,
                            payload: {
                                lastProdAddedToCart: productDetails.productName,
                            }
                        });
                        dispatch({
                            type: ActionConstants.SET_ALERT_MODEL,
                            payload: {
                                showAlertMsg: true,
                                isAddToCartSuccess: isUpdateToCartSuccess
                            }
                        });
                        dispatch({  // dispatching action to hide edit pop up
                            type: ActionConstants.HIDE_EDIT_MODEL_WIRELESS,
                            payload: {}
                        });


                        dispatch({   // dispatching action to hide add to cart loader
                            type: ActionConstants.ADD_PRODUCT_TO_CART_LOADER,
                            payload: {
                                addProductToCartInProgress: false,
                            }
                        });
                    }).finally(() =>

                    dispatch({   // dispatching action to reset the configure product data.
                            type: ActionConstants.WIRELESS_RESET_CONFIGURATION,
                            payload: {}
                        })

                    );
                }
            }
        };
    }

    static gotoPrevTabWireless() {
        return (dispatch, getState) => {
            let activeTab = getState().configWirelessProductData.payload.activeTab;
            dispatch({
                type: ActionConstants.WIRELESS_BACK_BUTTON_HANDLE,
                payload: {
                    activeTab: activeTab - 1,
                    nextbtn: 'Next',
                    enableNextBtn: true
                }
            });
        };
    }

    static onClickAddToCartButton(product: any, system: string, categoryName: string) {
        return (dispatch, getState) => {
            let aspireProductsInCart = getState().configProductData.payload.productsInCart;
            let apuProductsInCart = getState().configAPUData.payload.productsInCart;

            if (ProductAlertActions.checkInCompatibleProducts(aspireProductsInCart, system).length > 0
                || ProductAlertActions.checkInCompatibleProducts(apuProductsInCart, system).length > 0) { // this product is not compatible to add to cart.
                dispatch({
                    type: ActionConstants.SHOW_INCOMPATIBLE_TO_ADD_TO_CART,
                    payload: {
                        inCompatibleProducts: true
                    }
                });
            }
            // else if ((product.productId === CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_ID) &&
            //     (ProductAlertActions.checkIfDLMUWIsInCart(wirelessProducsInCart).length === 0)) {//DLMU-W is required
            //         dispatch(ConfigureWirelessActions.displayInvalidProductAlert(product));
            // }
            // else if ((product.productId === CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_ID) &&
            //     (ProductAlertActions.checkIfFaultAnalyzerInCart(wirelessProducsInCart).length === 0)) {//Fault Analyzer is required
            //     dispatch(ConfigureWirelessActions.displayInvalidProductAlert(product));
            // }
            else {  // we can add this product to cart.
                dispatch({
                    type: ActionConstants.WIRELESS_ADD_TO_CART_MODEL,
                    payload: {
                        product,
                        system,
                        categoryName,
                        configureWirelessModelOpen: true,
                    }
                });

                dispatch(ProductAlertActions.setGenricFields(system));
            }
        };
    }

    // static displayInvalidProductAlert(product){
    //     return(dispatch)=>{
    //         dispatch({
    //             type: ActionConstants.SHOW_INVALID_PRODUCT_TO_ADD_TO_CART,
    //             payload: {
    //                 invalidProducts: true,
    //                 productId: product.productId
    //             }
    //         });
    //     }
    // }

    /**
    * Method to redirect user to previous component. Resets component data.
    * @param currentPage
    */
    static onCancel(currentPage: any) {

        return dispatch => {
            dispatch({
                type: ActionConstants.SET_ALERT_MODEL,
                payload: {
                  showAlertMsg: false,
                  isAddToCartSuccess: false
                }
              });
            dispatch({
                type: ActionConstants.WIRELESS_RESET_CONFIGURATION,
                payload: {}
            });
            if (currentPage === routeConstants.MY_CART) {
                dispatch({
                    type: ActionConstants.HIDE_EDIT_MODEL_WIRELESS,
                    payload: {}
                });
            }
        };
    }

    static addAircraftRow() {
        return (dispatch, getState) => {
            const previousRowData = getState().configWirelessProductData.payload.aircraftDetailsArray;
            const wirelessPayload = getState().configWirelessProductData.payload;
            const validationFields = ['aircraftType', 'serialNum', 'tailNum', 'cartDuplicateSl', 'cartDuplicatetl'];
            let serialsInCart = ConfigureWirelessActions.serialsIncart(wirelessPayload);
            let tailsInCart = ConfigureWirelessActions.tailsIncart(wirelessPayload);
            const { validatedData, hasErrors } = validateAircraftInputData(previousRowData, validationFields, serialsInCart, tailsInCart);
            let updatedAircraftsData;

            if (hasErrors) {
                updatedAircraftsData = [...validatedData];
            }
            else {
                const newEmptyRow = {
                    aircraftType: '',
                    aircraftTypeError: '',
                    serialNumber: '',
                    serialNumberError: '',
                    tailNumber: '',
                    tailNumberError: '',
                    price: 0.00,
                };
                updatedAircraftsData = [...validatedData, newEmptyRow];
            }

            dispatch({
                type: ActionConstants.WIRELESS_ADD_AIRCRAFT,
                payload: {
                    updatedAircraftsData,
                    enableNextBtn: false
                }
            });
        };
    }

    static deleteAircraftRow(SelectedRows: []) {
        return (dispatch, getState) => {
            const wirelessPayload = getState().configWirelessProductData.payload;
            let previousRowData = wirelessPayload.aircraftDetailsArray;
            if (previousRowData.length >= 1 ) {
                previousRowData = previousRowData.filter((obj) => {
                    const indexFromSelectedRowData = SelectedRows.findIndex((x: any) => (x.aircraftType.id === obj.aircraftType.id && x.serialNumber === obj.serialNumber && x.tailNumber === obj.tailNumber));
                    let returnFilterObj;
                    if (indexFromSelectedRowData === -1) {
                        returnFilterObj = obj;
                    }
                    return returnFilterObj;
                });

                const validationFields = ['aircraftType', 'serialNum', 'tailNum'];
                const { validatedData, hasErrors } = validateAircraftInputData(previousRowData, validationFields, [], []);

                dispatch({
                    type: ActionConstants.WIRELESS_DELETE_AIRCRAFT,
                    payload: {
                        updatedAircraftsData: validatedData,
                        enableNextBtn: !hasErrors && wirelessPayload.acceptTermsStatus,
                    }
                });
            }
        };
    }

    static updateAircraftType(aircraftType: string, index: number) {
        return (dispatch, getState) => {
            const wirelessPayload = getState().configWirelessProductData.payload;
            let aircraftData = [...wirelessPayload.aircraftDetailsArray];
            aircraftData[index].aircraftType = aircraftType;
            const validationFields = ['aircraftType'];
            const { validatedData, hasErrors } = validateAircraftInputData(aircraftData, validationFields, [], []);

            dispatch({
                type: ActionConstants.WIRELESS_UPDATE_AIRCRAFT_TYPE,
                payload: {
                    aircraftData: validatedData,
                    enableNextBtn: !hasErrors,
                }
            });
        };
    }

    static updateAircraftSerial(updatedSerialNumber: string, index: number) {
        return (dispatch, getState) => {
            const wirelessPayload = getState().configWirelessProductData.payload;
            let serialsInCart = ConfigureWirelessActions.serialsIncart(wirelessPayload);

            if (('' + updatedSerialNumber).length <= 15) {
                let aircraftData = [...wirelessPayload.aircraftDetailsArray];
                aircraftData[index].serialNumber = updatedSerialNumber;

                const validationFields = ['serialNum', 'cartDuplicateSl'];
                const { validatedData, hasErrors } = validateAircraftInputData(aircraftData, validationFields, serialsInCart, []);
                dispatch({
                    type: ActionConstants.WIRELESS_UPDATE_AIRCRAFT_SERIAL,
                    payload: {
                        aircraftData: validatedData,
                        enableNextBtn: !hasErrors,
                    }
                });
            }
        };
    }
    static updateAircraftTail(updatedTailNumber: string, index: number) {
        return (dispatch, getState) => {
            const wirelessPayload = getState().configWirelessProductData.payload;

            let tailsInCart = ConfigureWirelessActions.tailsIncart(wirelessPayload);

            if (('' + updatedTailNumber).length <= 15) {
                let aircraftData = [...wirelessPayload.aircraftDetailsArray];
                aircraftData[index].tailNumber = updatedTailNumber;

                const validationFields = ['tailNum', 'cartDuplicatetl'];
                const { validatedData, hasErrors } = validateAircraftInputData(aircraftData, validationFields, [], tailsInCart);

                dispatch({
                    type: ActionConstants.WIRELESS_UPDATE_AIRCRAFT_TAIL,
                    payload: {
                        aircraftData: validatedData,
                        enableNextBtn: !hasErrors && wirelessPayload.acceptTermsStatus,
                    }
                });
            }
        };
    }

    static aircraftTypeInfoProcessing(flag: boolean) {
        return (dispatch) => {
            dispatch({
                type: ActionConstants.WIRELESS_AIRCRAFT_TYPE_PROCESSING,
                payload: {
                    isAircraftTypeInfoInProgress: flag,
                }
            });
        };
    }

    /**
     * Onchange method for Wireless product terms checkbox in Wireless Add serial number screen
     * @param acceptTermsStatus
     */
    static updateAcceptTermsStatus(acceptTermsStatus: boolean) {
        return (dispatch, getState) => {
            let acceptTermsErrorMsg = ''; // default error message
            const wirelessRowsData = getState().configWirelessProductData.payload.aircraftDetailsArray;
            const validationFields = ['aircraftType', 'serialNum', 'tailNum'];
            const { hasErrors } = validateAircraftInputData(wirelessRowsData, validationFields, [], []);

            if (!acceptTermsStatus) {
                // terms accepted
                acceptTermsErrorMsg = CheckoutUILabels.WIRELESS_PRODUCT_TERMS_ERROR_MSG;
            }
            dispatch({
                type: ActionConstants.UPDATE_WIRELESS_ACCEPT_TERMS_STATUS,
                payload: {
                    acceptTermsStatus,
                    acceptTermsErrorMsg,
                    enableNextBtn: !hasErrors && acceptTermsStatus
                }
            });
        };
    }
    static getAircraftTypes(data, aircraftTypeWirelessDeviceId) {
        let aircraftTypes = data.map((e: any) => ({ value: { id: e.modelId, name: e.name }, text: e.name }));

        return (dispatch) => {
            dispatch({
                type: ActionConstants.GET_WIRELESS_AIRCRAFT_TYPE,
                payload: {
                    aircraftTypes, aircraftTypeWirelessDeviceId
                }
            });
        };
    }

    // ASDS-1048 this will be called from OrderSummaryActions, to load cart data
    static setProductsInCart(data) {
        return (dispatch) => {
            dispatch({
                type: ActionConstants.LOAD_CART_DATA,
                payload: {
                    productsInCart: data.result.cart.products
                }
            });
        };
    }

    static serialsIncart(configData) {
        const editProductSeq = configData.editWirelessProductDetails.productSeq;
        const productsInCart = configData.productsInCart;
        const selectedProductID = configData.product.productId;

        let filteredCartProducts:Array<any> = [];

        if (editProductSeq) {
            // from cart page - ignoring validation for current cart line item
            filteredCartProducts = productsInCart.filter((product) => {
                return product.prodId === selectedProductID && product.wireless[0].prodSeq !== editProductSeq
            });
        } else {
            // from product listing page
            filteredCartProducts = productsInCart.filter((product) => {
                return product.prodId === selectedProductID;
            });
        }
        const serialArrayofArray = filteredCartProducts.map((product) => {
            return product.wireless.map((data) => {
                return data.aircraftSerialNum;
        });

        });
        let serialsInCart: any;
        serialsInCart = [].concat.apply([], serialArrayofArray);
        return serialsInCart;
    }

    static tailsIncart(configData) {
        const editProductSeq = configData.editWirelessProductDetails.productSeq;
        const productsInCart = configData.productsInCart;
        const selectedProductID = configData.product.productId;

        let filteredCartProducts;

        if (editProductSeq) {
            // from cart page - ignoring validation for current cart line item
            filteredCartProducts = productsInCart.filter((product) => {
                return product.prodId === selectedProductID && product.wireless[0].prodSeq !== editProductSeq
            });
        } else {
            // from product listing page
            filteredCartProducts = productsInCart.filter((product) => {
                return product.prodId === selectedProductID;
            });
        }

        const tailsArrayofArray = filteredCartProducts.map((product) => {
            return product.wireless.map(data => {
                return data.aircraftTailNo;
            });
        });
        let tailsCart: any;
        tailsCart = [].concat.apply([], tailsArrayofArray);

        return tailsCart;
    }
    static hideValidationErrorMsg(show: boolean) {
        return (dispatch) => {
            dispatch({
                type: ActionConstants.HIDE_VALIDATION_ERROR_MSG,
                payload: {
                    showValidationErrorMsg: show
                }
            });

        }

    }

}
export default ConfigureWirelessActions;